import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.NetSuiteInvoiceRequestForm.SalesDetailsSection', {
    salesDetailsSectionTitle: 'Sales Details',
    dateFieldPlaceholder: 'Select date',
    salesRepFieldText: 'Sales rep',
    salesRepFieldPlaceholder: 'Select sales rep',
    opportunityFieldText: 'Opportunity',
    opportunityFieldPlaceholder: 'Select opportunity',
    salesEffectiveDateFieldText: 'Sales effective date',
    excludeCommissionsFieldText: 'Exclude commissions',
    checkboxFieldPositiveValue: 'Yes',
    partnerFieldText: 'Partner',
    partnerFieldPlaceholder: 'Select partner',
    leadSourceFieldText: 'Lead source',
    leadSourceFieldPlaceholder: 'Select lead source',
});
